// @ts-ignore
import { appActionTypes } from 'src/app/newActionTypes';
import { filtersInitialValues } from 'src/app/reducers/initialStates';
import { fetchFilterData } from 'src/app/resolvers/filtersResolver';
import { appAvailableFilters } from 'src/config';
import { DATA_FILTER_DIR } from 'src/constants';

export const loadFilters = (dispatcher, config): void => {
  const filters = (config?.globals?.data?.filters ?? {}) as Record<string, string | undefined>;

  const filterFileNameKeysAndSiteCodeValues = {
    infringements: filters.infringements ?? 'default',
    noiseEvents: filters.noiseEvents ?? 'default',
    operations: filters.operations ?? 'default',
    airtrak: filters.airtrak ?? 'default',
    complaints: filters.complaints ?? 'default',
    settings: filters.settings ?? 'default',
    modelingAircraftAssignments: filters.modelingAircraftAssignments ?? 'default',
    reports: filters.reports ?? 'default',
  };

  const appFilters = { ...filtersInitialValues };

  const promises: any[] = [];
  let filtersToLoad = 'Filters to load: \n';
  Object.entries(filterFileNameKeysAndSiteCodeValues).forEach(([path, fileName]) => {
    if (
      fileName === 'default' ||
      appAvailableFilters.some( appFilter => {
        const filterString = `${DATA_FILTER_DIR}${path}/${fileName}`.toLowerCase();
        return (appFilter.toLowerCase() === filterString)
      }
      )
    ) {
      promises.push(fetchFilterData(path, fileName, appFilters));
      filtersToLoad += `\t ${path}: ${fileName}\n`;
    } else {
      promises.push(fetchFilterData(path, 'default', appFilters));
      filtersToLoad += `\t ${path}: using default ('${fileName}' specified, but not found)\n`;
    }
  });

  console.log(filtersToLoad);

  if (promises.length > 0) {
    Promise.all(promises)
      .then(() => {
        dispatcher({ type: appActionTypes.UPDATE_FILTERS, payload: appFilters });
      })
      .catch(() => {
        dispatcher({
          type: appActionTypes.FILTERS_ERROR,
          payload: appFilters,
        });
      });
  }
};
